import { SET_CHAIN } from 'redux/reducers/chain';

export function setChain(payload) {
    return {
        type: SET_CHAIN,
        payload,
    };
}
